export enum ELocale {
  ARGENTINA = 'es-AR',
  BRAZIL = 'pt-BR',
  MEXICO = 'es-MX'
}

export enum ECountry {
  ARGENTINA = 'AR',
  BRAZIL = 'BR',
  MEXICO = 'MX'
}

export enum ECurrency {
  ARGENTINA = 'ARS',
  BRAZIL = 'BRL',
  MEXICO = 'MXN',
  UNITED_STATES = 'USD'
}

export const ECurrencySymbol: Record<ECurrency, string> = {
  [ECurrency.BRAZIL]: 'R$',
  [ECurrency.MEXICO]: '$',
  [ECurrency.ARGENTINA]: '$',
  [ECurrency.UNITED_STATES]: 'US$'
};

export interface Translation {
  [key: string]: string | Translation;
}

export interface DomainTranslations {
  name: string;
  languages: {
    [ELocale.ARGENTINA]: Translation;
    [ELocale.MEXICO]: Translation;
    [ELocale.BRAZIL]: Translation;
  };
}
